module.exports = __webpack_public_path__ + "img/aus.c923b234.svg";